import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../api/client";
import { NewsDetail } from "./types";
import cls from "./NewsEdit.module.scss";

import ImageUpload from "./ImageUpload";
// ⬇️ новый импорт
import TinyMCEEditor from "../common/TinyMCEEditor";

type Props = { mode: "create" | "edit" };
const empty: NewsDetail = { id: 0, title: "", image: "", description: "", date: "", viewed: false };

const NewsEdit: React.FC<Props> = ({ mode }) => {
    const { id } = useParams();
    const nav = useNavigate();

    const [model, setModel] = useState<NewsDetail>(empty);
    const [loading, setLoading] = useState(mode === "edit");
    const [err, setErr] = useState<string | null>(null);
    const isEdit = mode === "edit";

    useEffect(() => {
        const load = async () => {
            if (!isEdit || !id) return;
            setLoading(true); setErr(null);
            try {
                const data = await api.get<NewsDetail>(`/api/news/${id}`);
                setModel({ ...data, description: data.description ?? "" });
            } catch (e: any) {
                setErr(e?.message || "Ошибка загрузки");
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [id, isEdit]);

    const save = async () => {
        try {
            const payload = {
                title: model.title,
                description: model.description || null,
                image: model.image || null,
                date: model.date,
            };
            if (isEdit && id) {
                await api.patch(`/api/news/${id}`, payload);
            } else {
                await api.post(`/api/news`, payload);
            }
            nav("/news");
        } catch (e: any) {
            alert(e?.message || "Не удалось сохранить");
        }
    };

    return (
        <div className={cls.card}>
            <h2 style={{ marginTop: 0 }}>{isEdit ? `Редактирование #${id}` : "Создание новости"}</h2>

            {loading ? "Загрузка…" : err ? (
                <div style={{ color: "crimson" }}>{err}</div>
            ) : (
                <div className={cls.grid}>
                    <label>
                        Заголовок
                        <input
                            className={cls.input}
                            value={model.title}
                            onChange={e => setModel({ ...model, title: e.target.value })}
                        />
                    </label>

                    <label>
                        Дата публикации
                        <input
                            className={cls.date}
                            type="date"
                            value={model.date || ""}
                            onChange={e => setModel({ ...model, date: e.target.value })}
                        />
                    </label>

                    <ImageUpload
                        value={model.image ?? ""}
                        onChange={(url) => setModel({ ...model, image: url || "" })}
                        uploadPath="/api/uploads"
                        fieldName="file"
                        label="Обложка"
                    />

                    {/* Описание — через наш компонент */}
                    <div>
                        <div style={{ fontWeight: 600, marginBottom: 6 }}>Описание</div>
                        <div className={cls.ckWrap}>
                            <TinyMCEEditor
                                value={model.description ?? ""}
                                onChange={(html) => setModel({ ...model, description: html })}
                                uploadUrl="/api/uploads"   // твой эндпоинт
                                uploadField="file"         // имя поля файла на бэке
                            />
                        </div>
                    </div>

                    <div className={cls.actions}>
                        <button className={`${cls.btn} ${cls.ghost}`} onClick={() => nav(-1)}>Отмена</button>
                        <button className={cls.btn} onClick={save}>{isEdit ? "Сохранить" : "Создать"}</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default NewsEdit;
